import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  transform(value: string, searchTerm: string): string {
    if (!searchTerm || !value) {
      return value; // Si no hay término de búsqueda o el valor es null/undefined, devolver el valor original
    }
    
    // Asegurarse de que value es una cadena
    const valueString = value.toString();

    // Crear expresión regular para buscar todas las ocurrencias (global e insensible a mayúsculas/minúsculas)
   // Escapar todos los caracteres especiales de regex antes de usarlos
    const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(${escapedTerm})`, 'gi');

    // Reemplazar todas las coincidencias con el término de búsqueda en negritas
    return valueString.replace(re, '<b>$1</b>');
  }
}
